import { useContext } from 'react';
import AppContext from 'external/components/Application/Context';

export default function useTheme() {
  const { theme, setTheme } = useContext(AppContext);
  return [theme, setTheme];
}
